import { LOCATION_CHANGE } from "connected-react-router";

export default function navigationReducer(
  state = {
    prevLocation: null,
    currentLocation: null,
  },
  { type, payload }
) {
  switch (type) {
    case LOCATION_CHANGE:
      return {
        ...state,
        prevLocation: state.currentLocation,
        currentLocation: payload.location,
      };
    default:
      return state;
  }
}
